import CommonApi from './../commonApi';
const pddGroup = new CommonApi('pddGroup', 'Темы ПДД');
export default {
  ...pddGroup
};
